import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateVendorContact } from '../../../state/vendorSlice';

const CityEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentVendor } = useAppSelector(state => state.vendor);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateVendorContact({ city: event.target.value }));
  };

  return (
    <TextField
      label="City"
      size="small"
      fullWidth
      value={currentVendor?.city || ''}
      onChange={handleChange}
    />
  );
};

export default CityEdit;
